import Axios from 'axios';



export default {

    send(data) {
        const BASE_URL = '/public/api/sms';
        //return Axios.get(BASE_URL+"/smsapi?key="+data.key+"&to="+data.to+"&msg="+data.msg+"&sender_id="+data.senderid,{headers,crossDomain: true });
        return Axios.get(BASE_URL+"/send",{params:data});
      },
    getBalance(key) {
        const BASE_URL = '/public/api/sms';
       // return Axios.get(BASE_URL+"/api/smsapibalance?key="+key);
       return Axios.get(BASE_URL+"/balance");
    },



}








// import Axios from 'axios';

// const proxyurl = "https://cors-anywhere.herokuapp.com/";
// const BASE_URL =  proxyurl+'https://apps.mnotify.net/smsapi';
// const headers= {
//   'Access-Control-Allow-Origin': '*',
// }

// export default {

//     send(data) {
//         return Axios.get(BASE_URL+"?key="+data.key+"&to="+data.to+"&msg="+data.msg+"&sender_id="+data.senderid,{headers,crossDomain: true });
//     },
//     getBalance(key) {
//         //console.log("keeyyy",key)
//         return Axios.get(BASE_URL+"/balance?key="+key);
//     },



// }
// import Axios from 'axios';

// //const BASE_URL = '/api/settings/';
// const BASE_URL = 'http://107.20.199.106/sms/2/text/single';
// var headers = {
//     'Content-Type': 'application/json',
//     'Accept': 'application/json',
//     'Access-Control-Allow-Origin': '*',
//     'Access-Control-Allow-Credentials': true,
//     'Authorization': ''
// }



// export default {

//     sendMsg(data) {
//         headers.Authorization = data.auth;
//         var jheaders = JSON.stringify(headers)

//         return Axios.post(BASE_URL, data.msg, { headers: jheaders, mode: 'cors' });
//     },



//}